import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import { createElement } from "commonAssets/lib/createElement";
import { modal } from "commonAssets/lib/modal";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { loadMember } from "commonAssets/lib/loadMember";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import {
    i18n,
    loading,
    outputDiv,
    reCAPTCHAv3,
} from "commonAssets/js/constants";
import { appPayMethod } from "commonAssets/js/constants";
import {
    dstPaymentIframeTitle,
    dstMember
} from "commonAssets/components/FormBase/DigitalDisbursements";
import {
    FormFields,
    FormFieldsLabel,
} from "commonAssets/components/FormBase/FormFields";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";
import { uploadFile } from "commonAssets/lib/uploadFile";
import formDefault from "../../docs/futureCoverage/formDefault.json";
import claimDeadlineAlertBody from "../../docs/futureCoverage/html/claim_deadline_alert_body.html?raw";
import claimDeadlineAlertForm from "../../docs/futureCoverage/html/claim_deadline_alert_form.html?raw";
import generalInstructionsBody from "../../docs/futureCoverage/html/general_instructions_body.html?raw";
import contactInformationBody from "../../docs/futureCoverage/html/contact_information_body.html?raw";

const htmlAssets = {
    "./html/claim_deadline_alert_body.html": claimDeadlineAlertBody,
    "./html/claim_deadline_alert_form.html": claimDeadlineAlertForm,
    "./html/general_instructions_body.html": generalInstructionsBody,
    "./html/contact_information_body.html": contactInformationBody,
};

let modelNumber;
let serialNumber;
let proofOfClassMembership1;
let proofOfClassMembership2;
let unableToProvideDocumentationSignature;
let unableToProvideDocumentationDate;
let paymentOptionForPreexistingWireHarnessIssue0;
let amountPaidForClassRefrigeratorPaymentOption;
let repairOptionForPreexistingWireHarnessIssue0;

export const valid_models = [
    "JSC23C9EEM00",
    "KRSC500ESS00",
    "KRSC500ESS01",
    "KRSC503EBS00",
    "KRSC503EBS01",
    "KRSC503ESS00",
    "KRSC503ESS01",
    "KRSC700HBS00",
    "KRSC700HBS01",
    "KRSC700HBS04",
    "KRSC700HPS00",
    "KRSC700HPS01",
    "KRSC700HPS04",
    "KRSC703HBS00",
    "KRSC703HBS01",
    "KRSC703HBS04",
    "KRSC703HPS00",
    "KRSC703HPS01",
    "KRSC703HPS04",
    "KRSF505EBL00",
    "KRSF505ESS00",
    "KRSF505ESS01",
    "KRSF505EWH00",
    "KRSF505EWH01",
    "KRSF705HBS00",
    "KRSF705HBS01",
    "KRSF705HBS04",
    "KRSF705HPS00",
    "KRSF705HPS01",
    "KRSF705HPS04",
    "MSB26C6MDE03",
    "MSB26C6MDH02",
    "MSB26C6MDM02",
    "MSC21C6MDM02",
    "MSC21C6MEZ00",
    "MSC21C6MFZ00",
    "MSC21C6MFZ05",
    "MSS25C4MGB00",
    "MSS25C4MGB03",
    "MSS25C4MGB06",
    "MSS25C4MGK00",
    "MSS25C4MGW00",
    "MSS25C4MGW03",
    "MSS25C4MGW06",
    "MSS25C4MGZ00",
    "MSS25C4MGZ03",
    "MSS25C4MGZ06",
    "MSS26C6MEZ00",
    "MSS26C6MFB00",
    "MSS26C6MFB01",
    "MSS26C6MFW00",
    "MSS26C6MFW01",
    "MSS26C6MFZ00",
    "WRS555SIHB00",
    "WRS555SIHB03",
    "WRS555SIHB06",
    "WRS555SIHV00",
    "WRS555SIHV03",
    "WRS555SIHV06",
    "WRS555SIHW00",
    "WRS555SIHW03",
    "WRS555SIHW06",
    "WRS555SIHZ00",
    "WRS555SIHZ03",
    "WRS555SIHZ06",
    "WRS571CIDB00",
    "WRS571CIDB01",
    "WRS571CIDB02",
    "WRS571CIDM01",
    "WRS571CIDM02",
    "WRS571CIDW00",
    "WRS571CIDW01",
    "WRS571CIHB00",
    "WRS571CIHB01",
    "WRS571CIHB02",
    "WRS571CIHB04",
    "WRS571CIHV00",
    "WRS571CIHV01",
    "WRS571CIHV02",
    "WRS571CIHV04",
    "WRS571CIHW00",
    "WRS571CIHW01",
    "WRS571CIHW02",
    "WRS571CIHW04",
    "WRS571CIHZ00",
    "WRS571CIHZ01",
    "WRS571CIHZ02",
    "WRS571CIHZ04",
    "WRS576FIDB01",
    "WRS576FIDB02",
    "WRS576FIDB03",
    "WRS576FIDM01",
    "WRS576FIDM02",
    "WRS576FIDW01",
    "WRS576FIDW02",
    "WRS586FIEE03",
    "WRS586FIEH03",
    "WRS586FIEH04",
    "WRS586FIEM01",
    "WRS586FIEM03",
    "WRS586FIEM04",
    "WRS586FIEM05",
    "WRS586FLDM01",
    "WRS586FLDM03",
    "WRS588FIHB00",
    "WRS588FIHB04",
    "WRS588FIHV00",
    "WRS588FIHV04",
    "WRS588FIHW00",
    "WRS588FIHW04",
    "WRS588FIHZ00",
    "WRS588FIHZ04",
    "WRS970CIDE01",
    "WRS970CIDH00",
    "WRS970CIDM00",
    "WRS970CIHZ00",
    "WRS970CIHZ01",
    "WRS973CIDM00",
    "WRS973CIHV00",
    "WRS973CIHV01",
    "WRS973CIHZ00",
    "WRS973CIHZ01",
    "WRS975SIDM00",
    "WRSA71CIHN00",
    "WRSA71CIHZ00",
    "WRSA71CIHZ01",
    "WRSA71CIHZ02",
    "WRSA71CIHZ04",
    "WRSA88FIHN00",
    "WRSA88FIHZ00",
    "KRSC700HBS05",
    "KRSC700HPS06",
    "KRSC703HBS05",
    "KRSC703HPS05",
    "KRSF505EBL02",
    "KRSF705HBS05",
    "KRSF705HPS05",
    "MSB26C6MDE00",
    "MSB26C6MDH00",
    "MSB26C6MDM00",
    "MSC21C6MDM00",
    "MSC21C6MFZ02",
    "MSS25C4MGB01",
    "MSS25C4MGB02",
    "MSS25C4MGB04",
    "MSS26C6MFB02",
    "MSS26C6MFW02",
    "MSS26C6MFZ02",
    "WRS342FIAB00",
    "WRS342FIAW00",
    "WRS555SIHB01",
    "WRS555SIHV01",
    "WRS555SIHW01",
    "WRS555SIHZ01",
    "WRS571CIDM00",
    "WRS571CIHB05",
    "WRS571CIHV05",
    "WRS571CIHW05",
    "WRS571CIHZ05",
    "WRS576FIDB00",
    "WRS586FIEE00",
    "WRS586FIEH00",
    "WRS586FIEM00",
    "WRS586FLDM00",
    "WRS588FIHB06",
    "WRS588FIHV06",
    "WRS588FIHW06",
    "WRS588FIHZ06",
    "WRS970CIDE00",
    "WRS970CIHZ04",
    "WRS973CIHZ04",
    "WRSA71CIHZ05",
    "MSB26C6MDE02",
    "MSS25C4MGB07",
    "MSS25C4MGW07",
    "MSS25C4MGZ08",
    "WRS555SIHB07",
    "WRS555SIHV07",
    "WRS555SIHW07",
    "WRS555SIHZ08",
    "WRS586FIEE01",
    "WRS586FIEH01",
    "WRS586FIEM02",
    "WRS586FLDM02",
    "WRS586FIEE02",
    "WRS586FIEH02",
]

function normalizeSerialNumber(value = "") {
    return value.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

function isEligibleSerialNumber(value = "") {
    const serial = normalizeSerialNumber(value);

    if (/^HR\d{8}$/.test(serial)) {
        const numericPortion = Number.parseInt(serial.slice(2), 10);
        return numericPortion >= 81800000 && numericPortion <= 99999999;
    }

    if (/^HRX\d{7}$/.test(serial)) {
        return true;
    }

    if (/^HRA\d{7}$/.test(serial)) {
        const numericPortion = Number.parseInt(serial.slice(3), 10);
        return numericPortion >= 0 && numericPortion <= 3999999;
    }

    return false;
}

export class customSubmitFutureCoverageClaim extends SubmitClaim {
    async form() {
        const baseUrl = new URL(
            "../../docs/futureCoverage/formDefault.json",
            window.location.href
        ).href;
        const config = await SubmitClaim.resolveHtmlFields(formDefault, {
            baseUrl,
            assets: htmlAssets,
        });
        const form = config.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitFutureCoverageClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    claim_deadline() {
        return createElement("div", { class: "d-none" });
    }

    guard(params, getDeadline) {
        const formElement = super.guard(params, getDeadline);
        const notice = createElement(
            "div",
            {
                class: "alert alert-info text-center fw-bold",
                id: "future-coverage-notice",
            },
            [],
            "This claim portal is for Wire Harness Issues that occurred after May 5, 2026."
        );
        formElement.insertBefore(notice, formElement.firstChild);
        return formElement;
    }

    claim_form(params, additionalParams) {
        const formElement = super.claim_form(params, additionalParams);
        const deadlineHeading = formElement.querySelector("#claimFormDeadline");
        if (deadlineHeading) {
            deadlineHeading.remove();
        }
        return formElement;
    }

    async destroy_claim(claim) {
        loadingGif(loading, "show")

        const renderParentClaimConfirmation = () =>
            super.claim_confirmation(claim.data);

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            let email = {
                domain: claim.data.domain,
                zero_zero_id: claim.data.zero_zero_id,
                confirmation_code: claim.data.confirmation_code,
                claim_id: claim.data.claim_id,
            };
            
            claim.api.claimsEmailPost({}, email);

            //JSB
            fbq('track', 'Lead');
            gtag_report_conversion();

            if (document.getElementById('uploading_photographic_evidence_0').checked || document.getElementById('cash_payment_upload_from_smartphone_0').checked) {
                let api_url;
                let hostname = this.hostname();
                if (
                    hostname.startsWith("local") ||
                    hostname === "localhost" ||
                    hostname.split(".")[1] === "angeiontest"
                ) {
                    api_url = "https://apigateway-submissions.staging.angeiontestsite.com/staging";
                } else {
                    api_url = "https://apigateway-submissions.production.angeiongroup.com/production";
                }

                // Render a host-side placeholder immediately because the uploader root
                // exists before the refrigerator-specific uploader login request runs.
                // Without this content, the page shows an awkward blank/late transition
                // while we wait for `/cases/4279/login` to return and only then call
                // `ClaimPhotoUploader.mount(...)`. The uploader bundle replaces this
                // placeholder as soon as mount begins, so this text is only a bridge
                // between the claim form handoff and the real uploader UI.
                const uploaderRoot = createElement(
                    "div",
                    {
                        id: "claim-photo-uploader-root",
                        class: "py-4",
                        "aria-live": "polite",
                    },
                    [
                        createElement(
                            "h3",
                            { class: "mb-2" },
                            [],
                            "Preparing photo upload session..."
                        ),
                        createElement(
                            "p",
                            { class: "mb-0 text-secondary" },
                            [],
                            "Please wait while we load your claim details."
                        ),
                    ]
                );

                const renderUploaderError = (title, message) => {
                    uploaderRoot.replaceChildren(
                        createElement(
                            "div",
                            { class: "alert alert-danger mb-0", role: "alert" },
                            [
                                createElement("h3", { class: "h5 mb-2" }, [], title),
                                createElement("p", { class: "mb-0" }, [], message),
                            ]
                        )
                    );
                };

                const submissionMessage = createElement("div", { class: "m-3", id: "submission-message" }, [
                    createElement("p", {}, [], `Your Claim Form has been submitted successfully. You will receive a confirmation email to the email provided. Your Claim ID is <strong>${claim.data.zero_zero_id}</strong>.`),
                    createElement("p", {}, [], `On your Claim Form you selected the option to upload photos to support your claim. If you do not have any photos to upload, you may exit this page.  Please reach out to the Settlement Administrator with any questions.`),
                ]);

                document.getElementById("output").appendChild(submissionMessage);
                document.getElementById("output").appendChild(uploaderRoot);
                loadingGif(loading, "hide", 250);

                try {
                    const loginResponse = await fetch(
                        `${api_url}/cases/4279/login`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                zero_zero_id: claim.data.zero_zero_id,
                                confirmation_code: claim.data.confirmation_code,
                                case_id: 4279,
                                data: {
                                    email_address: "new_claimant",
                                },
                            }),
                        }
                    );

                    let loginData = {};
                    try {
                        loginData = await loginResponse.json();
                    } catch (error) {
                        console.error("ClaimPhotoUploader login response was not valid JSON", error);
                    }

                    if (!loginResponse.ok) {
                        console.error("ClaimPhotoUploader host login failed", {
                            status: loginResponse.status,
                            body: loginData,
                        });

                        if (loginResponse.status === 401 || loginResponse.status === 403) {
                            renderUploaderError(
                                "We couldn't verify your photo upload access.",
                                "Please confirm your claim details and try again. If the problem continues, contact support."
                            );
                        } else {
                            renderUploaderError(
                                "Photo uploads are temporarily unavailable.",
                                "We couldn't start your photo upload session right now. Please try again later or contact support."
                            );
                        }

                        return;
                    }

                    if (!loginData.token) {
                        console.error("ClaimPhotoUploader host login returned no token", loginData);
                        renderUploaderError(
                            "Photo uploads are temporarily unavailable.",
                            "We couldn't start your photo upload session right now. Please try again later or contact support."
                        );
                        return;
                    }

                    if (!window.ClaimPhotoUploader || typeof window.ClaimPhotoUploader.mount !== "function") {
                        console.error("ClaimPhotoUploader bundle is unavailable");
                        renderUploaderError(
                            "Photo uploader failed to load.",
                            "Please refresh the page and try again. If the problem continues, contact support."
                        );
                        return;
                    }

                    window.ClaimPhotoUploader.mount({
                        target: "#claim-photo-uploader-root",
                        auth: {
                            token: loginData.token,
                        },
                        claimContext: {
                            zeroZeroId: String(claim.data.zero_zero_id),
                        },
                        transport: {
                            baseUrl: api_url,
                            allowedOrigins: [api_url.replace(/\/(staging|production)$/, "")],
                        },
                        runtime: {
                            mode: "production",
                        },
                        callbacks: {
                            onReady(payload) {
                                console.log("ClaimPhotoUploader ready", payload);
                            },
                            onError(error) {
                                console.error("ClaimPhotoUploader error", error);
                            },
                            onSubmitted(submission) {
                                document.getElementById('submission-message').classList.add('d-none');
                                document.getElementById('claim-photo-uploader-root').classList.add('d-none');
                                outputDiv.appendChild(
                                    renderParentClaimConfirmation()
                                );
                                outputDiv.scrollIntoView({ behavior: "smooth" });

                                setTimeout(() => {
                                    modal(
                                        i18n.getTranslation("confirmation_screen_additional")[
                                            "title"
                                        ],
                                        i18n.getTranslation("confirmation_screen_additional")[
                                            "body"
                                        ]
                                    );
                                }, 250);            
                            }

                        },
                    });
                } catch (error) {
                    console.error("ClaimPhotoUploader host handoff failed", error);
                    renderUploaderError(
                        "Photo uploads are temporarily unavailable.",
                        "We couldn't start your photo upload session right now. Please try again later or contact support."
                    );
                }

                return;
            }

            outputDiv.appendChild(renderParentClaimConfirmation());
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(
                    i18n.getTranslation("confirmation_screen_additional")[
                        "title"
                    ],
                    i18n.getTranslation("confirmation_screen_additional")[
                        "body"
                    ]
                );
            }, 250);            
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }

    claim_fieldset(params) {
        if (params.claim_fields_sectioned === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields_sectioned.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const claimFields = createElement("div", {
            id: "claim-fields"
        }, [
            this.claim_field_sections(params)
        ])
        return claimFields;
    }

    claim_field_sections(params) {
        const claimFieldSections = createElement("div", {});

        params.claim_fields_sectioned.forEach((section) => {
            claimFieldSections.append(createElement("fieldset", { class: "bg-light text-dark border rounded p-3 mb-5" }, [
                createElement("div", { class: "h3 mb-3 formTitle" }, [], section.title),
                createElement("div", { class: "mb-3 formBody" }, [], section.body),
                this.claim_fields(section.fields),
            ]))
        })
        return claimFieldSections;
    }

    claim_fields(fields) {
        const container = createElement("div");

        let fieldID = 0;  //
        fields.forEach(field => {
            let element;
            let validation;
            let className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: (field.parentClass ? field.parentClass : "mb-3 _wrapper"),
                "data-field-id": "_" + (field.name ? field.name : "_wrapper_" + fieldID)
            });
            element = FormFields(field, className, fieldID, element, validation, container);
            FormFieldsLabel(field, fieldID, div);

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");

        // Redirect non-Future-Coverage claims back to the regular claim form
        // so the correct fields render and submit correctly.
        if (class_member.claim_id) {
            const formTypeField = (class_member.claim_fields || []).find(
                (field) => field.name === "Form Type"
            );
            if (!formTypeField || formTypeField.value !== "Future Coverage") {
                window.location.replace("/submit-claim");
                return;
            }
        }

        // set user for error tracking
        this.errorHandler.set_user({
            id: class_member.zero_zero_id,
            email: class_member.email_address,
        });
        // remove guard
        document.getElementById("guard").remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M.
        const deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Load member data into form
        loadMember(class_member);
        // custom login member code
        if (class_member.claim_id) {
            if (class_member.claim_files && class_member.claim_files.length > 0) {
                this.prev_uploads = true;
            }
        }
        let cm_data = class_member.class_member || class_member;
        // Payment widget
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_fields(claim, form, claim_deadline) {
        const formType = document.getElementById("form_type");
        if (formType) {
            formType.value = "Future Coverage";
        }

        modelNumber = document.getElementById("model_number");
        serialNumber = document.getElementById("serial_number");
        proofOfClassMembership1 = document.getElementById("proof_of_class_membership_1");
        proofOfClassMembership2 = document.getElementById("proof_of_class_membership_2");
        unableToProvideDocumentationSignature = document.getElementById("unable_to_provide_documentation_signature");
        unableToProvideDocumentationDate = document.getElementById("unable_to_provide_documentation_date");
        paymentOptionForPreexistingWireHarnessIssue0 = document.getElementById("payment_option_for_preexisting_wire_harness_issue_0");
        amountPaidForClassRefrigeratorPaymentOption = document.getElementById("amount_paid_for_class_refrigerator_payment_option");
        repairOptionForPreexistingWireHarnessIssue0 = document.getElementById("repair_option_for_preexisting_wire_harness_issue_0");

        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("init");
        }

        // Check for file documentation section
        if (document.getElementById("documentation")) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {
            document.getElementById("form").setAttribute("novalidate", "true");

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            document
                .getElementById("submit-claim")
                .addEventListener("click", () => {
                    document
                        .getElementById("form")
                        .classList.add("was-validated");
                });

            document
                .getElementById("form")
                .addEventListener("submit", (process) => {
                    this.process_claim(process, this.claim, claim_deadline);
                });
        }

        if (!proofOfClassMembership2.checked) {
            unableToProvideDocumentationSignature.disabled = true;
            toggleFieldAttributeV2(unableToProvideDocumentationSignature, "required", false);
            toggleFieldError(unableToProvideDocumentationSignature, false);
        }

        unableToProvideDocumentationDate.disabled = true;

        if (!paymentOptionForPreexistingWireHarnessIssue0.checked) {
            amountPaidForClassRefrigeratorPaymentOption.disabled = true;
            toggleFieldAttributeV2(amountPaidForClassRefrigeratorPaymentOption, "required", false);
        }

        if (repairOptionForPreexistingWireHarnessIssue0.checked) {
            paymentOptionForPreexistingWireHarnessIssue0.disabled = true;
         }

        if (paymentOptionForPreexistingWireHarnessIssue0.checked) {
            repairOptionForPreexistingWireHarnessIssue0.disabled = true;
        }

        // Event listeners for field toggles
        proofOfClassMembership1.addEventListener("change", () => {
            unableToProvideDocumentationSignature.disabled = true;
            toggleFieldAttributeV2(unableToProvideDocumentationSignature, "required", false);
            toggleFieldError(unableToProvideDocumentationSignature, false);
            unableToProvideDocumentationSignature.value = '';
            unableToProvideDocumentationDate.value = '';
        });

        proofOfClassMembership2.addEventListener("click", () => {
            unableToProvideDocumentationSignature.disabled = false;
            toggleFieldAttributeV2(unableToProvideDocumentationSignature, "required", true);
        });

        unableToProvideDocumentationSignature.addEventListener("change", () => {
            if (unableToProvideDocumentationSignature.value !== '') {
                const date = new Date();
                const formattedDate = date.toLocaleString('en-US', { 
                    year: 'numeric', 
                    month: 'numeric', 
                    day: 'numeric', 
                    hour: 'numeric', 
                    minute: '2-digit', 
                    second: '2-digit', 
                    hour12: true 
                });
                unableToProvideDocumentationDate.value = formattedDate;
            } else {
                unableToProvideDocumentationDate.value = '';
            }
        });

         paymentOptionForPreexistingWireHarnessIssue0.addEventListener("click", (e) => {
             amountPaidForClassRefrigeratorPaymentOption.disabled = !e.target.checked;
             toggleFieldAttributeV2(amountPaidForClassRefrigeratorPaymentOption, "required", e.target.checked);
             if (!e.target.checked) {
                amountPaidForClassRefrigeratorPaymentOption.value = '';
                toggleFieldError(amountPaidForClassRefrigeratorPaymentOption, false);
             }
         });

        repairOptionForPreexistingWireHarnessIssue0.addEventListener("click", (e) => {
            paymentOptionForPreexistingWireHarnessIssue0.disabled = e.target.checked;
            if (e.target.checked) {
                paymentOptionForPreexistingWireHarnessIssue0.checked = false;
            }
         });

        paymentOptionForPreexistingWireHarnessIssue0.addEventListener("click", (e) => {
            repairOptionForPreexistingWireHarnessIssue0.disabled = e.target.checked;
            if (e.target.checked) {
                repairOptionForPreexistingWireHarnessIssue0.checked = false;
            }
         });

        const uploadingDocumentsFromComputer0 = document.getElementById("uploading_documents_from_computer_0");
        const uploadingPhotographicEvidence0 = document.getElementById("uploading_photographic_evidence_0");

        if (uploadingDocumentsFromComputer0.checked) {
            uploadingPhotographicEvidence0.disabled = true;
        }
        if (uploadingPhotographicEvidence0.checked) {
            uploadingDocumentsFromComputer0.disabled = true;
        }

        uploadingDocumentsFromComputer0.addEventListener("click", (e) => {
            uploadingPhotographicEvidence0.disabled = e.target.checked;
            if (e.target.checked) {
                uploadingPhotographicEvidence0.checked = false;
            }
        });

        uploadingPhotographicEvidence0.addEventListener("click", (e) => {
            uploadingDocumentsFromComputer0.disabled = e.target.checked;
            if (e.target.checked) {
                uploadingDocumentsFromComputer0.checked = false;
            }
        });

        const cashPaymentUploadFromComputer0 = document.getElementById("cash_payment_upload_from_computer_0");
        const cashPaymentUploadFromSmartphone0 = document.getElementById("cash_payment_upload_from_smartphone_0");
        const repairInServiceUploadDocumentation0 = document.getElementById("repair_in_service_upload_documentation_0");
        const repairInServiceUseManufactureDate0 = document.getElementById("repair_in_service_use_manufacture_date_0");

        if (!paymentOptionForPreexistingWireHarnessIssue0.checked) {
            cashPaymentUploadFromComputer0.disabled = true;
            cashPaymentUploadFromSmartphone0.disabled = true;
        }
        if (!repairOptionForPreexistingWireHarnessIssue0.checked) {
            repairInServiceUploadDocumentation0.disabled = true;
            repairInServiceUseManufactureDate0.disabled = true;
        }
        if (cashPaymentUploadFromComputer0.checked) {
            cashPaymentUploadFromSmartphone0.disabled = true;
        }
        if (cashPaymentUploadFromSmartphone0.checked) {
            cashPaymentUploadFromComputer0.disabled = true;
        }
        if (repairInServiceUploadDocumentation0.checked) {
            repairInServiceUseManufactureDate0.disabled = true;
        }
        if (repairInServiceUseManufactureDate0.checked) {
            repairInServiceUploadDocumentation0.disabled = true;
        }

        paymentOptionForPreexistingWireHarnessIssue0.addEventListener("click", (e) => {
            cashPaymentUploadFromComputer0.disabled = !e.target.checked;
            cashPaymentUploadFromSmartphone0.disabled = !e.target.checked;
            if (!e.target.checked) {
                cashPaymentUploadFromComputer0.checked = false;
                cashPaymentUploadFromSmartphone0.checked = false;
            }
        });

        repairOptionForPreexistingWireHarnessIssue0.addEventListener("click", (e) => {
            repairInServiceUploadDocumentation0.disabled = !e.target.checked;
            repairInServiceUseManufactureDate0.disabled = !e.target.checked;
            if (!e.target.checked) {
                repairInServiceUploadDocumentation0.checked = false;
                repairInServiceUseManufactureDate0.checked = false;
            }
        });

        cashPaymentUploadFromComputer0.addEventListener("click", (e) => {
            cashPaymentUploadFromSmartphone0.disabled = e.target.checked;
            if (e.target.checked) {
                cashPaymentUploadFromSmartphone0.checked = false;
            }
        });

        cashPaymentUploadFromSmartphone0.addEventListener("click", (e) => {
            cashPaymentUploadFromComputer0.disabled = e.target.checked;
            if (e.target.checked) {
                cashPaymentUploadFromComputer0.checked = false;
            }
        });

        repairInServiceUploadDocumentation0.addEventListener("click", (e) => {
            repairInServiceUseManufactureDate0.disabled = e.target.checked;
            if (e.target.checked) {
                repairInServiceUseManufactureDate0.checked = false;
            }
        });

        repairInServiceUseManufactureDate0.addEventListener("click", (e) => {
            repairInServiceUploadDocumentation0.disabled = e.target.checked;
            if (e.target.checked) {
                repairInServiceUploadDocumentation0.checked = false;
            }
        });

        serialNumber.addEventListener("change", () => {
            if (serialNumber.value === "") {
                toggleFieldError(serialNumber, false);
                return;
            }
            if (isEligibleSerialNumber(serialNumber.value)) {
                toggleFieldError(serialNumber, false);
            } else {
                toggleFieldError(serialNumber, true, "Please enter a valid serial number.");
            }
        });

        modelNumber.addEventListener("change", () => {
            const normalizedModel = modelNumber.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
            if (normalizedModel === "") {
                toggleFieldError(modelNumber, false);
                return;
            }
            if (valid_models.includes(normalizedModel)) {
                toggleFieldError(modelNumber, false);
            } else {
                toggleFieldError(modelNumber, true, "Please enter a valid model number.");
            }
        });

        loadingGif(loading, "hide", 1000);
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
        //     claim = dstProcess(this.claim);
        // }
        // else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        if (serialNumber.value != "" && !isEligibleSerialNumber(serialNumber.value)) {
            toggleFieldError(serialNumber, true, "Please enter a valid serial number.");
            claim.flags.valid = false;
        }

        if (modelNumber.value != "" && !valid_models.includes(modelNumber.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))) {
            toggleFieldError(modelNumber, true, "Please enter a valid model number.");
            claim.flags.valid = false;
        }

        if (!document.getElementById('uploading_photographic_evidence_0').checked && !document.getElementById('uploading_documents_from_computer_0').checked) {
            custom_errors += `<br>Please select at least one option in Step 2: Section C.`
            claim.flags.valid = false;
        }

        if (!repairOptionForPreexistingWireHarnessIssue0.checked && !paymentOptionForPreexistingWireHarnessIssue0.checked) {
            custom_errors += `<br>Please select at least one option in Step 3.`
            claim.flags.valid = false;
        }

        if (
            paymentOptionForPreexistingWireHarnessIssue0.checked &&
            !document.getElementById('cash_payment_upload_from_computer_0').checked &&
            !document.getElementById('cash_payment_upload_from_smartphone_0').checked
        ) {
            custom_errors += `<br>Please select an upload method for the Cash Payment Option in Step 3.`
            claim.flags.valid = false;
        }

        if (
            repairOptionForPreexistingWireHarnessIssue0.checked &&
            !document.getElementById('repair_in_service_upload_documentation_0').checked &&
            !document.getElementById('repair_in_service_use_manufacture_date_0').checked
        ) {
            custom_errors += `<br>Please select an In-Service Date evidence option for the Repair Option in Step 3.`
            claim.flags.valid = false;
        }

        if (paymentOptionForPreexistingWireHarnessIssue0.checked) {

            if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
                custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
                claim.flags.valid = false;
            }

            if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
                custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
                claim.flags.valid = false;
            }

            if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
                custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
                claim.flags.valid = false;
            }
        }

        if (
            (
                proofOfClassMembership1.checked ||
                document.getElementById('uploading_documents_from_computer_0').checked ||
                document.getElementById('cash_payment_upload_from_computer_0').checked ||
                document.getElementById('repair_in_service_upload_documentation_0').checked
            )
            &&
            claim.uploads.length === 0
            &&
            !this.prev_uploads
         ) {
            custom_errors += `<br>Please upload supporting documentation.`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    async post_claim(claim, s3env) {
        console.log("[post_claim]");

        /**
         * Set the claim as sent.
         *
         * @returns {void}
         */
        claim.flags.sent = true;

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Removed: 2023.09.25 (moved to process_claim) due to multiple submissions.
         *
         * @returns {void}
         */
        // document.getElementById('submit-claim').disabled = true;

        /**
         * Wait 0.5 seconds before display loading gif
         * (Lambda in sleep mode)
         *
         * @returns {void}
         */
        const t = window.setTimeout(() => {
            loadingGif(loading, "show");
        }, 250);

        // Update claim if an existing claim id
        if (claim.data.claim_id) {
            claim.flags.method = "claimsPut";
        }


        /**
         * Paul Pomerleau - October 18th, 2023
         * If the device has a local device token it's added to the claim fields before posting
         */
        const deviceToken = localStorage.getItem("X-Device-Token");
        if (deviceToken) claim.data.fields.device_token = deviceToken;

        console.log(claim.flags.method)

        // Post/Put claims data
        claim.api[claim.flags.method.replaceAll('V4', 'V2')]({}, claim.data)
            .then(async function (result) {
                // Lambda error message
                if (result.data.error) {
                    clearTimeout(t);
                    claim.flags.success = false;
                    modal(i18n.getTranslation("error"), result.data.error);
                    return;
                }

                console.log(result)

                /**
                 * Save correlation id
                 */
                claim.data.claim_id = result.data.claim_id;
                claim.data.zero_zero_id = result.data.zero_zero_id;
                claim.data.confirmation_code = result.data.confirmation_code;
                claim.flags.success = true;
                /**
                 * Process the claim uploads and upload the files.
                 */
                try {
                    if (claim.uploads.length && claim.uploads.length > 0) {
                        for (let f = 0; f < claim.uploads.length; f++) {
                            await uploadFile(claim, s3env, claim.uploads[f], f, 0);
                        }
                    }
                } catch (error) {
                    console.log(error)
                    claim.errorHandler.log_exception(
                        new Error("Error uploading claim files", { cause: error })
                    );
                    claim.errorHandler.display_modal(error);
                }
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error posting claim", { cause: error })
                );
                this.errorHandler.display_modal(error);
                claim.flags.success = false;
            })
            .finally(() => {
                // debugger;
                clearTimeout(t);
                loadingGif(loading, "hide", 250);
                if (claim.flags.success) {
                    this.destroy_claim(claim);
                } else {
                    document.getElementById("submit-claim").disabled = false;
                    claim.flags.sent = false;
                }

                // Remove editClaim link on Claim Confirmation
                const editClaim = document.getElementById("editClaim");
                if (editClaim !== null) {
                    editClaim.remove();
                }
            });
    }
}
